export default __webpack_public_path__ + "static/media/2266.5a5d5cdb.png";